const get = async (url, onSuccess, onFail) => {

    try {

        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "include"
        });

        const data = await response.json();

        if(!response.ok) {
            if(typeof onFail === "function") {
                onFail(response, data);
                return;
            } else {
                return;
            }
        }

        if(typeof onSuccess === "function") {
            onSuccess(response, data);
        }

    } catch (err) {
        console.error(err);
        if (typeof onFail === "function") {
            onFail();
        }
    }

}; export default get;